import React from "react";

export default class Required extends React.PureComponent {
    render() {
        return (
            <span className={'form-required required'}>*</span>
        )
    }
}
